import { createSlice } from "@reduxjs/toolkit";
import APPCONFIG from "constants/appConfig";
import axios from "axios";
import { getUser } from "services/auth";
import { appdataSelector, appdata_setSnackbar } from "reducers/appdata/appdata";

export const initialState = {
  loading: false,
  orders: {}, // keys are weeknumber, days weeknumber:[date:{},date:{}],weeknumber:[etc]
  ordersForGroups: {}, // keys are weeknumber, days weeknumber:[date:{},date:{}],weeknumber:[etc]
  ordersForExternal: {}
};

export const orderdataSlice = createSlice({
  name: "orderdata",
  initialState,
  reducers: {
    orderdata_setLoading: (state, action) => {
      state.loading = action.payload;
    },
    orderdata_setOrders: (state, action) => {
      console.log("orderdata - set orders", action.payload);
      let key = Object.keys(action.payload)[0];
      let target = action.payload.forGroups ? "ordersForGroups" : "orders";
      target = getUser()["isExternal"] ? "ordersForExternal" : target;
      let id = action.payload.id ? action.payload.id : false;
      console.log("setorders, target: ", target);

      let toUpdate = {};
      console.log("1", toUpdate);
      if (action.payload.forGroups) {
        console.log("go groups", action.payload, key, id);
        if (action.payload.date) {
          console.log("go groups single");
          toUpdate = { ...state[target][key] };
          console.log("go groups single 1", toUpdate);
          toUpdate[action.payload.date] =
            action.payload[key][action.payload.date];
          console.log("go groups single 2", toUpdate);
        } else {
          console.log("go groups all");
          toUpdate = action.payload[key];
        }
        /* toUpdate = { ...state[target][key] };
        console.log("2",toUpdate);
        toUpdate[id] = action.payload[key][id];
        console.log("3",toUpdate); */
      } else {
        toUpdate = action.payload[key];
      }

      state[target][key] = toUpdate;
      /* 
      return {
        ...state,
        [target]: { ...state[target], [key]: action.payload[key] }
      }; */
    },
    orderdata_updateGroupOrderForDay: (state, action) => {
      console.log("orderdata - updateGroupOrderForDay", action.payload);
      let id = action.payload.id ? action.payload.id : 0;
      let weeknumber = action.payload.weeknumber;
      let date = action.payload.date;
      let values = action.payload.values;
      let saved = action.payload.savedToSap ? action.payload.savedToSap : false;
      let saving = action.payload.saving ? action.payload.saving : false;

      let external = getUser()["isExternal"];
      let target = external ? "ordersForExternal" : "ordersForGroups";

      if (!state[target][weeknumber]) {
        state[target][weeknumber] = {};
      }

      if (!state[target][weeknumber][date]) {
        state[target][weeknumber][date] = {};
      }

      // check if there are already orders for the given date
      // if so, we should alter the id to make the new id the length of the orders,
      // but only if there was no id given (that means a new order)
      if (!external) {
        if (
          !action.payload.id &&
          Object.keys(state[target][weeknumber][date]).length > 0
        ) {
          id = Object.keys(state[target][weeknumber][date]).length;
        }
      }

      if (!external && !state[target][weeknumber][date][id]) {
        state[target][weeknumber][date][id] = {};
      }

      let toUpdate = {
        ...state[target][weeknumber][date][id],
        ORDER_DATE: date,
        savedToSap: saved,
        saving: saving
      };

      if (external) {
        toUpdate = {
          ...state[target][weeknumber][date],
          ORDER_DATE: date,
          savedToSap: saved,
          saving: saving
        };
      }

      if (values) {
        Object.keys(values).map(key => {
          toUpdate[key] = values[key];
        });
      }

      console.log("toUpdate", toUpdate);

      if (!external) {
        state[target][weeknumber][date][id] = toUpdate;
      } else {
        state[target][weeknumber][date] = toUpdate;
      }
    },

    orderdata_updateOrderForDay: (state, action) => {
      console.log("orderdata - orderdata_updateOrderForDay", action.payload);
      let weeknumber = action.payload.weeknumber;
      let date = action.payload.date;
      let values = action.payload.values;
      let saved = action.payload.savedToSap ? action.payload.savedToSap : false;

      let toUpdate = { ORDER_DATE: date, savedToSap: saved };

      if (values) {
        Object.keys(values).map(key => {
          toUpdate[key] = values[key];
        });
      }

      return {
        ...state,
        orders: {
          ...state.orders,
          [weeknumber]: {
            ...state.orders[weeknumber],
            [date]: {
              ...state.orders[weeknumber][date],
              ...toUpdate
            }
          }
        }
      };
    }
  }
});

export const {
  orderdata_setLoading,
  orderdata_setOrders,
  orderdata_updateOrderForDay,
  orderdata_updateGroupOrderForDay
} = orderdataSlice.actions;

export const orderdataSelector = state => state.orderdata;

export default orderdataSlice.reducer;

export function orderdata_saveOrderToSAP(params) {
  console.log("orderdata - orderdata_saveOrderToSAP", params);
  return async (dispatch, getState) => {
    if (params.group) {
      dispatch(
        orderdata_updateGroupOrderForDay({
          saving: true,
          savedToSap: false,
          weeknumber: params.weeknumber,
          date: params.date,
          id: params.id
        })
      );
    } else {
      // set the order for the day to be unsaved and clear the data
      dispatch(
        orderdata_updateOrderForDay({
          savedToSap: false,
          weeknumber: params.weeknumber,
          date: params.date
        })
      );
    }

    // update the data in SAP
    const axiosConfig = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      withCredentials: true
    };

    axios
      .post(
        APPCONFIG.host + "api/lunchorder/order",
        {
          order: params.values,
          group: params.group ? params.group : false
        },
        axiosConfig
      )
      .then(response => {
        let snackMessage = "";
        console.log("order saved to SAP", JSON.parse(response.data).data);
        console.log("Params:", params.values);
        if((params.values["MENU1"] == "0" && params.values["MENU2"] == "0" && params.values["MENU3"] == "0") || (params.values["CANCEL"] != undefined && params.values["CANCEL"] == "X") ){
          snackMessage = "Order canceled successfully";
        }else {
          snackMessage = "Order saved successfully";
        }

        dispatch(appdata_setSnackbar({open:true,message:snackMessage,severity:"success"}))

  

        let savedOrder = JSON.parse(response.data).data;

        console.log("savedOrder", savedOrder);

        if (params.group) {
          dispatch(
            orderdata_setOrders({
              [params.weeknumber]: formatOrders(
                JSON.parse(response.data).data,
                true
              ),
              forGroups: true,
              date: params.date
            })
          );
        } else {
          dispatch(
            orderdata_updateOrderForDay({
              savedToSap: true,
              weeknumber: params.weeknumber,
              date: params.date,
              values: savedOrder
            })
          );
        }
      })
      .catch(error => {
        console.log("error", error, params);
        dispatch(
          
          orderdata_updateOrderForDay({
            savedToSap: true,
            weeknumber: params.weeknumber,
            date: params.date
          })
        );
        dispatch(
          appdata_setSnackbar({open:true,message:"Order not saved", error,severity:"error"})
        );
      });
  };
}

export function orderdata_fetchData(forGroups, dates) {
  console.log("orderdata - fetchdata", dates);
  return async (dispatch, getState) => {
    dispatch(orderdata_setLoading(true));

    var weeknumber = getState().scheduledata.selectedWeekNumber;
    let week = getState().scheduledata.dates[weeknumber];

    console.log("orderdata - week", week);

    axios
      .get(
        APPCONFIG.host +
          "api/lunchorder/orderForDays/" +
          forGroups +
          "/" +
          JSON.stringify(Object.values(week).join()),
        {
          withCredentials: true,
          timeout: APPCONFIG.axiosTimeout,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => {
        console.log(
          "orderdata - orders received",
          forGroups,
          JSON.parse(response.data)
        );

        // map days to simple objects incuding a 'saved to sap' variable
        dispatch(
          orderdata_setOrders({
            [weeknumber]: formatOrders(
              JSON.parse(response.data).data,
              forGroups
            ),
            forGroups: forGroups
          })
        );

        dispatch(orderdata_setLoading(false));
      })
      .catch(er => {
        console.error("orderdata error", er);
        //dispatch(setError());
        dispatch(orderdata_setLoading(false));
      });
  };
}

function formatOrders(weekdata, forGroups) {
  let week = {};
  let externalUser = getUser()["isExternal"];
  Object.keys(weekdata).map(key => {
    let day = {};
    Object.keys(weekdata[key]).map(daykey => {
      if (externalUser) {
        // format for externaluser with extra data
        // format for externaluser with extra data
        // format for externaluser with extra data
        // format for externaluser with extra data
        if (
          weekdata[key][daykey]["PROJECT"] == getUser()["userPrincipalName"]
        ) {
          day = {
            savedToSap: true,
            MENU1_NUMB: weekdata[key][daykey]["MENU1_NUMB"],
            MENU2_NUMB: weekdata[key][daykey]["MENU2_NUMB"],
            MENU3_NUMB: weekdata[key][daykey]["MENU3_NUMB"],
            MENU1: weekdata[key][daykey]["MENU1"],
            MENU2: weekdata[key][daykey]["MENU2"],
            MENU3: weekdata[key][daykey]["MENU3"],
            BLDG_LOC: weekdata[key][daykey]["BLDG_LOC"],
            CANCEL: weekdata[key][daykey]["CANCEL"],
            PERSNO: weekdata[key][daykey]["PERSNO"],
            COST_CENTER: weekdata[key][daykey]["COST_CENTER"],
            ORDER_DATE: weekdata[key][daykey]["ORDER_DATE"],
            ORDER_NUMB: weekdata[key][daykey]["ORDER_NUMB"],
            PROJECT: weekdata[key][daykey]["PROJECT"]
          };
        }
      } else if (!forGroups) {
        // format for normal user
        // format for normal user
        // format for normal user
        // format for normal user
        day = {
          savedToSap: true,
          MENU1_NUMB: weekdata[key][daykey]["MENU1_NUMB"],
          MENU2_NUMB: weekdata[key][daykey]["MENU2_NUMB"],
          MENU3_NUMB: weekdata[key][daykey]["MENU3_NUMB"],
          MENU1: weekdata[key][daykey]["MENU1"],
          MENU2: weekdata[key][daykey]["MENU2"],
          MENU3: weekdata[key][daykey]["MENU3"],
          BLDG_LOC: weekdata[key][daykey]["BLDG_LOC"],
          CANCEL: weekdata[key][daykey]["CANCEL"],
          PERSNO: weekdata[key][daykey]["PERSNO"],
          COST_CENTER: weekdata[key][daykey]["COST_CENTER"],
          ORDER_DATE: weekdata[key][daykey]["ORDER_DATE"]
        };
      } else {
        // format for groups (as array)
        // format for groups (as array)
        // format for groups (as array)
        // format for groups (as array)
        // format for groups (as array)
        day[daykey] = {
          savedToSap: true,
          saving: false,
          PERSNO: weekdata[key][daykey]["PERSNO"],
          ORDER_DATE: weekdata[key][daykey]["ORDER_DATE"],
          MENU1_NUMB: weekdata[key][daykey]["MENU1_NUMB"],
          MENU2_NUMB: weekdata[key][daykey]["MENU2_NUMB"],
          MENU3_NUMB: weekdata[key][daykey]["MENU3_NUMB"],
          MENU1: weekdata[key][daykey]["MENU1"],
          MENU2: weekdata[key][daykey]["MENU2"],
          MENU3: weekdata[key][daykey]["MENU3"],
          BLDG_LOC: weekdata[key][daykey]["BLDG_LOC"],
          CANCEL: weekdata[key][daykey]["CANCEL"],
          COST_CENTER: weekdata[key][daykey]["COST_CENTER"],
          PROJECT: weekdata[key][daykey]["PROJECT"],
          COMPANY: weekdata[key][daykey]["COMPANY"],
          ORDER_NUMB: weekdata[key][daykey]["ORDER_NUMB"]
        };
      }
    });

    if (Object.keys(day).length > 0) week[key] = day;
  });
  return week;
}
